import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private toastr: ToastrService,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error) => {
        const isRefreshRequest =
          request.url.includes('/tokens/refresh') ||
          error.url?.includes('/tokens/refresh');

        if (
          [401, 403].includes(error.status) &&
          this.authService.userData &&
          !isRefreshRequest
        ) {
          this.authService.logout();
        }

        // A non-JSON or empty body used to throw here (JSON.parse, or reading .messages off
        // null), which killed the handler before it could toast — so those failures reached the
        // user as nothing at all, indistinguishable from a request that had succeeded.
        let errorMsg: any = error.error;
        if (typeof errorMsg === 'string') {
          try {
            errorMsg = JSON.parse(errorMsg);
          } catch {
            // Plain-text body: usable as a message, unless it is an HTML error page.
            const text = errorMsg.trim();
            errorMsg =
              text && !text.startsWith('<') ? { messages: [text] } : null;
          }
        }

        let err: string;
        if (errorMsg?.messages?.length) {
          err = errorMsg.messages.join(' ');
        } else {
          err = error.statusText || 'Something went wrong. Please try again.';
        }

        if (err === 'Invalid Refresh Token.') {
          err =
            'Somebody logged in with your credentials from another computer. Your session closed, please log in again.';
        }
        if (err.includes('The order is already Approved by')) {
          err = err + '. Order data can not be changed.';
        }
        if (err !== 'Check your email and enter the 2fa code.') {
          this.toastr.error(`${err}`, 'Error');
        } else {
          this.toastr.info('Check your email and enter the 2fa code.', 'Info');
        }
        return throwError(() => {
          return new Error(err);
        });
      }),
    );
  }
}
